import{createContext as e}from"react";const o=e({activeIndexes:[],onToggle:()=>null});export{o as AccordionContext};
//# sourceMappingURL=AccordionContext.js.map
